<template>
  <div class="ml-2">
    <a href="#" class="my-auto mb-1 btn btn-sm btn-secondary" data-toggle="modal" data-target="#createProjectModal"
       title="Create project" :style="{'height': '30px'}">
      <span class="mr-2 d-none d-md-inline-block">Create project</span>
      <span class="icon icon-add-more mr-0"></span>
    </a>
    <div class="modal fade" id="createProjectModal" tabIndex="-1" aria-labelledby="createProjectModalTitle"
         aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="createProjectModalTitle">Create new project</h5>
            <button type="button" id="closeModalButton" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col">
                <label>What is the new project name ?</label>
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="new project name" aria-label="ProjectName"
                         aria-describedby="basic-addon1" v-model="projectName"></div>
                <small class="align-middle mt-1 pt-1">A project is a set of collections.<br>Each collection is a set of uploaded tables.</small>
              </div>

              <div class="form-group col">
                <label>Collections ?</label>
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="collections names list" aria-label="CollectionsString"
                         aria-describedby="basic-addon1" v-model="collectionsString"></div>
                <small class="align-middle mt-1 pt-1">(comma separated list of strings)</small>
              </div>

            </div>
            <hr>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Abort</button>
              <button type="button" class="btn btn-primary" v-on:click="onCreateProjectSubmit">Create this project
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import CreateProjectRequest from "../../generatedApiClient/api/model/CreateProjectRequest";

import ProjectApi from '../../generatedApiClient/api/endpoints/ProjectApi';

let projectApiInstance = new ProjectApi();

export default {
  name: "ProjectAdder",
  components: {},
  data() {
    return {
      projectName: undefined,
      collectionsString: undefined
    }
  },
  mounted() {
  },
  computed: {
    signedUser: function () {
      return (this.$store.state.identityIdentified !== undefined) ? this.$store.state.identityIdentified.email : undefined;
    },
    collectionList: function () {
      if ( this.collectionsString) {
        return this.collectionsString.split(',');
      } else {
        return [];
      }
    }
  },
  methods: {
    updateAuthJwtToken: function (apiInstance) {
      if (apiInstance && apiInstance.apiClient && apiInstance.apiClient.authentications && apiInstance.apiClient.authentications['AuthJWT']) {
        apiInstance.apiClient.authentications['AuthJWT'].accessToken = this.$store.state.identityIdentified.token;
      }
    },
    emitProjectAdded: function () {
      this.$emit('project-added', {});
    },
    emitProjectAddedError: function () {
      this.$emit('project-added-error', {});
    },
    onCreateProjectSubmit: function () {
      this.updateAuthJwtToken(projectApiInstance);

      // {
      //   name: 'Project 1',
      //       collections: ['collec1', 'secondCollection', 'anotherNewCollection']
      // };


      projectApiInstance.createProject(this.signedUser, { name:this.projectName, collections: this.collectionList})
          .then(createProjectResp => {
            console.log("[getOrCreateProjects] [API] [createProject] [OK]");
            //this.$store.commit('selectProject', {id: createProjectResp.id, name: createProjectResp.name});
            this.emitProjectAdded(createProjectResp);
            document.getElementById('closeModalButton').click();
          })
          .catch(createProjectError => {
            console.log("[getOrCreateProjects] [API] [createProject] [ERROR]", createProjectError);
            this.emitProjectAddedError(createProjectError);
            document.getElementById('closeModalButton').click();
          })


    }
  }
}
</script>

<style scoped>

.modal {
  font-size: medium;
}

</style>